// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"26d97e1d","625":"3bd1673b"}[chunkId] + ".chunk.css";
};